<app-presentation-shell [isMobile]="isMobile()">
  <div class="presentation" [ngClass]="{ 'presentation-top-captions': captionsOpened() }">
    @if (speakingParticipantsV1()) {
      <app-presentation-speakers class="presentation-speakers"> </app-presentation-speakers>
    }

    @if (!isGroupSharing()) {
      <app-presentation-presenter-sharing
        [isCaptionsOpen]="captionsOpened()"
        [isSharingScreen]="screenShareActive()"
        [isGalleryDrawerOpen]="drawerOpenState()"
        [isPresentersDrawerOpen]="isPresentersDrawerOpen()"
        [ngClass]="{ 'screen-sharing': presentationV3() && screenShareActive() }"
      ></app-presentation-presenter-sharing>
    }
    @if (embeddedMedia()) {
      <app-presentation-presenter-embed
        class="w-full"
        [ngClass]="{ 'video-embed-sharing': presentationV3() }"
        [embeddedMedia]="embeddedMedia()"
        [isGalleryDrawerOpen]="drawerOpenState()"
      >
      </app-presentation-presenter-embed>
    }
    @if (!isGroupSharing() && activePresenters()) {
      <app-presentation-presenter-videos
        [isSharingScreen]="screenShareActive() || !!embeddedMedia()"
        [isGalleryDrawerOpen]="drawerOpenState()"
        (presentersDrawerOpenEmitter)="setIsPresentersDrawerOpen($event)"
      ></app-presentation-presenter-videos>
    }
    @if (!screenShareActive() && isGroupSharing()) {
      <app-presentation-group-share
        [isCaptionsOpen]="captionsOpened()"
        [isGroupSharing]="isGroupSharing()"
        [isGalleryDrawerOpen]="drawerOpenState()"
        [ngClass]="{ 'screen-sharing': presentationV3() }"
      ></app-presentation-group-share>
    }
  </div>
</app-presentation-shell>
